module.exports = __webpack_public_path__ + "static/media/user.acb45a20.svg";